module.exports = __webpack_public_path__ + "static/media/YF73_02.f751bab8.jpg";